import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import {
  FIREBASE_API_KEY,
  FIREBASE_APP_ID,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_MEASUREMENT_ID,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET,
} from "src/app.config";

export const firebaseConfig = {
  apiKey: FIREBASE_API_KEY,
  appId: FIREBASE_APP_ID,
  authDomain: FIREBASE_AUTH_DOMAIN,
  measurementId: FIREBASE_MEASUREMENT_ID,
  messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
  projectId: FIREBASE_PROJECT_ID,
  storageBucket: FIREBASE_STORAGE_BUCKET,
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const initializeFirebaseSW = () => {
  // Register service worker with debug logging
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", async () => {
      try {
        const registration = await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js"
        );

        registration.addEventListener("updatefound", () => {});
      } catch (error) {
        if (error instanceof Error) {
          // console.error("Error details:", {
          //   name: error.name,
          //   message: error.message,
          //   stack: error.stack,
          // });
        }
      }
    });
  }
};
